<template>
  <v-app-bar app color="primary" dark>
    <v-toolbar-title>{{ t('agent.agentCenter') }}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn icon>
      <v-icon>mdi-bell</v-icon>
    </v-btn>
    <v-menu offset-y>
      <template v-slot:activator="{ props }">
        <v-btn icon v-bind="props">
          <v-icon>mdi-account-circle</v-icon>
          <v-icon right>mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="logout">
          <v-list-item-title>
            {{ t('common.logout') }} 
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-btn icon @click="toggleDrawer">
      <v-icon>mdi-menu</v-icon>
    </v-btn>
    <v-menu offset-y>
        <template v-slot:activator="{ props }">
          <v-btn text v-bind="props">
            🌏{{ currentLanguage }}
            <v-icon right>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-for="lang in languages" :key="lang.code" @click="changeLanguage(lang.code, lang.label)">
            <v-list-item-title :class="lang.label === currentLanguage ? 'selected-language' : ''">{{ lang.label }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
  </v-app-bar>
</template>

<script setup>
import { ref, getCurrentInstance } from 'vue';
import { useI18n } from 'vue-i18n';

const { t, locale } = useI18n();
const { proxy } = getCurrentInstance();
const languages = [
  { code: 'zhHant', label: '繁體' },
  { code: 'en', label: 'English' },
  { code: 'ko', label: '한국어' },
];
const currentLanguage = ref("繁體");
const toggleDrawer = () => {
  proxy.$emit('toggle-drawer');
};
const changeLanguage = (code, language) => {
  locale.value = code;
  currentLanguage.value = language;
};
const logout = () => {
  proxy.$eventBus.emit('user-logout');
};
</script> 
